import { ICON_NAMES } from '../../constants';
import { createBuilderModule } from '../../builder';
import { Article } from './Article';
import { DEFAULT_VALUES } from './fixtures';

export default createBuilderModule(Article, {
  name: 'Article',
  image: 'https://cdn.zappy.app/1a634bb631bc562d9e341eb75fa9ee5e.svg',
  inputs: [
    {
      name: 'layout',
      type: 'string',
      enum: ['card', 'row'],
      required: true,
      defaultValue: DEFAULT_VALUES.layout,
    },
    {
      name: 'url',
      type: 'string',
      required: true,
      defaultValue: DEFAULT_VALUES.url,
    },
    {
      name: 'imageUrl',
      type: 'cloudinaryImage',
      required: true,
      defaultValue: DEFAULT_VALUES.imageUrl,
    },
    {
      name: 'title',
      type: 'string',
      required: true,
      defaultValue: DEFAULT_VALUES.title,
    },
    {
      name: 'description',
      type: 'richText',
      defaultValue: DEFAULT_VALUES.description,
    },
    {
      name: 'authorName',
      type: 'string',
      required: true,
      defaultValue: DEFAULT_VALUES.authorName,
    },
    {
      name: 'authorImageUrl',
      type: 'cloudinaryImage',
      defaultValue: DEFAULT_VALUES.authorImageUrl,
    },
    {
      name: 'authorEmail',
      type: 'string',
      helperText: "Used for Gravatar if author image URL isn't provided",
    },
    {
      name: 'category',
      type: 'string',
    },
    {
      name: 'categoryUrl',
      type: 'string',
    },
    {
      name: 'label',
      type: 'string',
    },
    {
      name: 'labelIcon',
      type: 'string',
      enum: Object.values(ICON_NAMES),
    },
    {
      name: 'labelVariant',
      type: 'string',
      enum: ['primary', 'secondary', 'neutral'],
    },
    {
      name: 'metaDate',
      type: 'date',
    },
    {
      name: 'metaReadTime',
      type: 'number',
    },
  ],
});
